// ============================================================================
// ITALIAN TRANSLATIONS - CHAPTER 5: LA CHIESA PRIMITIVA
// ============================================================================
// Livelli 53-65 (13 livelli, 39 domande)

export const chapter5Translations = {
  name: "La Chiesa Primitiva",
  description: "Riceverete potenza...",
  
  spiritualWisdom: {
    principle: "Lo Spirito Santo dà potenza e coraggio per testimoniare",
    scripture: "Riceverete potenza quando lo Spirito Santo verrà su di voi e mi sarete testimoni (Atti 1:8)",
    application: "La Chiesa nasce nel fuoco dello Spirito e cresce attraverso la testimonianza coraggiosa"
  },
  
  levels: {
    53: {
      name: "L'Ascensione",
      challenge: "Sarete miei testimoni... fino all'estremità della terra...",
      easy: {
        question: "Quanti giorni dopo la sua risurrezione Gesù ascese al cielo?",
        options: ["30 giorni", "40 giorni", "50 giorni", "60 giorni"],
        hint: "Il numero biblico della preparazione",
        funFact: "☁️ 40 giorni di insegnamento intensivo prima della missione mondiale!"
      },
      medium: {
        question: "Quale promessa fa Gesù prima di ascendere al cielo?",
        options: [
          "Tornerà presto",
          "Invierà lo Spirito Santo con potenza",
          "Costruirà una chiesa",
          "Punirà i malvagi"
        ],
        hint: "Una potenza dall'alto",
        funFact: "⚡ Promessa dello Spirito Santo - trasformazione dei discepoli paurosi!"
      },
      hard: {
        question: "Cosa simboleggia l'Ascensione nella nostra vita spirituale?",
        options: [
          "La fine della presenza di Gesù",
          "Gesù regna e intercede per noi in cielo",
          "Una separazione definitiva",
          "Un mito simbolico"
        ],
        hint: "Si tratta della sua presenza glorificata e attiva",
        funFact: "👑 Gesù regna alla destra di Dio e intercede per noi!"
      }
    },
    
    54: {
      name: "La Pentecoste",
      challenge: "Furono tutti ripieni di Spirito Santo e cominciarono a parlare...",
      easy: {
        question: "Quanti giorni dopo l'Ascensione ebbe luogo la Pentecoste?",
        options: ["7 giorni", "10 giorni", "14 giorni", "20 giorni"],
        hint: "Una decina di giorni",
        funFact: "🔟 10 giorni di preghiera intensa preparano all'effusione dello Spirito!"
      },
      medium: {
        question: "Sotto quale forma apparve lo Spirito Santo?",
        options: [
          "Come un vento impetuoso",
          "Come lingue di fuoco",
          "Come una colomba",
          "Come una luce"
        ],
        hint: "Fiamme che si posano su ogni discepolo",
        funFact: "🔥 Lingue di fuoco: lo Spirito dà coraggio e dono delle lingue!"
      },
      hard: {
        question: "Cosa rappresenta la Pentecoste per la Chiesa universale?",
        options: [
          "Un evento storico isolato",
          "La nascita ufficiale della Chiesa missionaria",
          "Un miracolo di curiosità",
          "L'inizio delle celebrazioni"
        ],
        hint: "Si tratta dell'atto di nascita della Chiesa",
        funFact: "🎂 Pentecoste = compleanno della Chiesa, inizio della missione mondiale!"
      }
    },

    55: {
      name: "Il Primo Sermone di Pietro",
      challenge: "Che dobbiamo fare, fratelli? Pentitevi...",
      easy: {
        question: "Quante persone furono battezzate dopo il sermone di Pietro?",
        options: ["1000", "2000", "3000", "5000"],
        hint: "Tremila anime",
        funFact: "🌊 3000 battesimi in un giorno - risveglio spirituale straordinario!"
      },
      medium: {
        question: "Di cosa Pietro accusò la folla?",
        options: [
          "Di ignoranza",
          "Di aver crocifisso Gesù, il Messia",
          "Di mancanza di fede",
          "Di ipocrisia"
        ],
        hint: "Il crimine supremo contro il Figlio di Dio",
        funFact: "⚔️ Pietro, che aveva rinnegato Gesù, ora proclama la sua divinità!"
      },
      hard: {
        question: "Come illustra la trasformazione di Pietro l'opera dello Spirito Santo?",
        options: [
          "Diventa più istruito",
          "Da codardo e instabile, diventa coraggioso e fermo nella fede",
          "Acquisisce poteri",
          "Cambia personalità"
        ],
        hint: "Si tratta della santificazione per mezzo dello Spirito",
        funFact: "🗿 La 'canna agitata' diventa 'pietra ferma' - potenza trasformatrice!"
      }
    },

    56: {
      name: "La Prima Comunità",
      challenge: "Perseveravano nella dottrina degli apostoli, nella comunione...",
      easy: {
        question: "Come condividevano i loro beni i primi cristiani?",
        options: [
          "Ognuno teneva il suo",
          "Avevano tutto in comune",
          "Solo i ricchi davano",
          "Per obbligo legale"
        ],
        hint: "Comunità di beni volontaria",
        funFact: "🤝 Amore fraterno così intenso che condividono tutto spontaneamente!"
      },
      medium: {
        question: "A cosa dedicavano il loro tempo i primi cristiani?",
        options: [
          "Solo agli affari",
          "Dottrina, comunione, frazione del pane, preghiere",
          "Solo al lavoro",
          "Al tempo libero"
        ],
        hint: "Quattro pilastri della vita comunitaria",
        funFact: "⛪ Dottrina, comunione, eucaristia, preghiera - fondamenta della Chiesa!"
      },
      hard: {
        question: "Perché questa prima comunità era così attraente?",
        options: [
          "Era ricca",
          "L'amore autentico e la gioia irradiavano dalla loro unità",
          "Prometteva miracoli",
          "Criticava gli altri"
        ],
        hint: "Si tratta della testimonianza dell'amore vissuto",
        funFact: "✨ 'Guardate come si amano!' - testimonianza che convince più delle parole!"
      }
    },

    57: {
      name: "La Guarigione dello Zoppo",
      challenge: "Dell'argento e dell'oro non ne ho; ma quello che ho te lo do...",
      easy: {
        question: "Da quanto tempo l'uomo era zoppo?",
        options: [
          "Da 20 anni",
          "Da 30 anni", 
          "Dalla nascita",
          "Da 10 anni"
        ],
        hint: "Un'infermità da sempre",
        funFact: "🚶 40 anni di infermità guariti istantaneamente nel nome di Gesù!"
      },
      medium: {
        question: "Nel nome di chi Pietro guarì lo zoppo?",
        options: [
          "Nel nome di Dio",
          "Nel nome di Gesù Cristo il Nazareno",
          "Nel suo proprio nome",
          "Nel nome di Abramo"
        ],
        hint: "Il nome al di sopra di ogni nome",
        funFact: "✊ Il nome di Gesù continua a operare miracoli attraverso gli apostoli!"
      },
      hard: {
        question: "Cosa simboleggia questa guarigione per il Vangelo?",
        options: [
          "Un semplice miracolo medico",
          "La salvezza totale che Gesù porta: spirituale e fisica",
          "Il potere degli apostoli",
          "La carità verso i poveri"
        ],
        hint: "Si tratta della salvezza integrale dell'essere umano",
        funFact: "🩺 Gesù guarisce l'anima e il corpo - salvezza completa della persona!"
      }
    },

    58: {
      name: "Inizia la Persecuzione",
      challenge: "Bisogna ubbidire a Dio anziché agli uomini...",
      easy: {
        question: "Chi arrestò Pietro e Giovanni dopo la guarigione dello zoppo?",
        options: [
          "I romani",
          "I sadducei e i sacerdoti",
          "Il popolo",
          "Pilato"
        ],
        hint: "Le autorità religiose giudaiche",
        funFact: "⛓️ Prima persecuzione religiosa - il Vangelo disturba l'establishment!"
      },
      medium: {
        question: "Quale divieto diedero le autorità agli apostoli?",
        options: [
          "Di lasciare Gerusalemme",
          "Di non insegnare più nel nome di Gesù",
          "Di non fare più miracoli",
          "Di non pregare più"
        ],
        hint: "Divieto di predicare",
        funFact: "🚫 Tentano di far tacere la verità - impossibile fermare il Vangelo!"
      },
      hard: {
        question: "Come reagirono gli apostoli al divieto?",
        options: [
          "Obbedirono per paura",
          "Affermarono di dover ubbidire a Dio anziché agli uomini",
          "Negoziarono",
          "Fuggirono"
        ],
        hint: "Si tratta di una fedeltà più alta delle leggi umane",
        funFact: "⚖️ Disobbedienza civile per obbedire a Dio - coraggio della convinzione!"
      }
    },

    59: {
      name: "Anania e Saffira",
      challenge: "Tu non hai mentito agli uomini ma a Dio...",
      easy: {
        question: "Quale menzogna dissero Anania e Saffira?",
        options: [
          "Non avevano venduto nulla",
          "Davano tutto il prezzo della vendita mentre ne trattenevano una parte",
          "Erano poveri",
          "Non erano sposati"
        ],
        hint: "Menzogna sull'importo dato",
        funFact: "💰 Trattenere una parte era permesso, mentire sull'offerta no!"
      },
      medium: {
        question: "Cosa accadde loro dopo la loro menzogna?",
        options: [
          "Furono perdonati",
          "Morirono improvvisamente",
          "Furono esclusi",
          "Si pentirono"
        ],
        hint: "Punizione immediata e severa",
        funFact: "⚱️ Giudizio severo per preservare la purezza della Chiesa nascente!"
      },
      hard: {
        question: "Perché questa punizione così severa all'inizio della Chiesa?",
        options: [
          "Dio era crudele",
          "Per stabilire la santità richiesta nella comunità",
          "Per fare paura",
          "Per caso"
        ],
        hint: "Si tratta di preservare l'integrità spirituale",
        funFact: "🔥 Standard elevati all'inizio per stabilire la cultura della santità!"
      }
    },

    60: {
      name: "I Sette Diaconi",
      challenge: "Scegliete fra voi sette uomini di buona reputazione...",
      easy: {
        question: "Quanti diaconi furono scelti?",
        options: ["5", "6", "7", "12"],
        hint: "Il numero della perfezione",
        funFact: "7️⃣ Sette diaconi per il servizio - organizzazione divina della Chiesa!"
      },
      medium: {
        question: "Qual era il loro ruolo principale?",
        options: [
          "Predicare il Vangelo",
          "Servire alle tavole e aiutare le vedove",
          "Battezzare i nuovi convertiti",
          "Gestire le finanze"
        ],
        hint: "Servizio sociale e materiale",
        funFact: "🍽️ Servizio alle tavole = prima organizzazione caritativa cristiana!"
      },
      hard: {
        question: "Cosa rivela questa organizzazione sulla visione cristiana del servizio?",
        options: [
          "I compiti materiali sono inferiori",
          "Servizio spirituale e materiale sono entrambi sacri",
          "Bisogna separare il sacro dal profano",
          "Solo i sacerdoti servono veramente"
        ],
        hint: "Si tratta della sacralità di ogni servizio d'amore",
        funFact: "✨ Servire alle tavole con la stessa dignità di predicare - ogni servizio è sacro!"
      }
    },

    61: {
      name: "Stefano, Primo Martire",
      challenge: "Signore, non imputare loro questo peccato! E detto questo si addormentò...",
      easy: {
        question: "Qual era la funzione di Stefano nella Chiesa?",
        options: ["Apostolo", "Diacono", "Sacerdote", "Profeta"],
        hint: "Uno dei sette scelti per servire",
        funFact: "✨ Stefano: diacono divenne evangelista potente e primo martire!"
      },
      medium: {
        question: "Di cosa Stefano accusò i capi giudei?",
        options: [
          "Di corruzione",
          "Di aver sempre resistito allo Spirito Santo",
          "Di ipocrisia",
          "Di cupidigia"
        ],
        hint: "Resistenza storica a Dio",
        funFact: "📜 Stefano riassume la storia: ribellione costante contro Dio!"
      },
      hard: {
        question: "Come morì Stefano e cosa rivela il suo atteggiamento?",
        options: [
          "Nella rabbia contro i suoi carnefici",
          "Perdonando come Gesù sulla croce",
          "Nella disperazione",
          "Maledicendo i suoi nemici"
        ],
        hint: "Si tratta dell'imitazione perfetta di Cristo",
        funFact: "💝 Perdono dei carnefici: Stefano riproduce perfettamente l'atteggiamento di Gesù!"
      }
    },

    62: {
      name: "Filippo e l'Eunuco Etiope",
      challenge: "Come potrei capire se nessuno mi guida?",
      easy: {
        question: "Cosa leggeva l'eunuco nel suo carro?",
        options: [
          "I Salmi",
          "Il profeta Isaia",
          "La Genesi",
          "I Proverbi"
        ],
        hint: "Il profeta della Passione del Messia",
        funFact: "📖 Isaia 53 - profezia perfetta su Gesù letta da un cercatore sincero!"
      },
      medium: {
        question: "Come Filippo spiegò il passo di Isaia?",
        options: [
          "Parlò di storia antica",
          "Annunciò Gesù a partire da questo testo",
          "Diede una lezione di teologia",
          "Criticò le interpretazioni"
        ],
        hint: "La Scrittura conduce naturalmente a Cristo",
        funFact: "✝️ Tutta la Scrittura converge verso Gesù - chiave di comprensione!"
      },
      hard: {
        question: "Cosa simboleggia la conversione dell'eunuco etiope?",
        options: [
          "Una conversione isolata",
          "L'universalità del Vangelo per tutte le razze e condizioni",
          "La superiorità di certi popoli",
          "Un caso particolare"
        ],
        hint: "Si tratta dell'apertura alle nazioni",
        funFact: "🌍 Etiope, eunuco, ministro: il Vangelo rompe tutte le barriere!"
      }
    },

    63: {
      name: "La Conversione di Saulo di Tarso",
      challenge: "Saulo, Saulo, perché mi perseguiti?",
      easy: {
        question: "Cosa faceva Saulo prima della sua conversione?",
        options: [
          "Predicava il Vangelo",
          "Perseguitava i cristiani",
          "Era neutrale",
          "Studiava soltanto"
        ],
        hint: "Nemico accanito dei discepoli",
        funFact: "⚔️ Saulo spirava minacce e strage contro i discepoli di Gesù!"
      },
      medium: {
        question: "Su quale strada Gesù apparve a Saulo?",
        options: [
          "La strada di Gerusalemme",
          "La strada di Damasco",
          "La strada di Gaza",
          "La strada di Antiochia"
        ],
        hint: "Una città della Siria",
        funFact: "🛤️ Strada di Damasco = luogo di trasformazione più famoso della storia!"
      },
      hard: {
        question: "Come illustra questa conversione la grazia divina?",
        options: [
          "Dio converte solo i buoni",
          "La grazia può trasformare il peggiore nemico nel più grande apostolo",
          "La conversione era meritata",
          "Saulo era già vicino a Dio"
        ],
        hint: "Si tratta del potere trasformatore della grazia",
        funFact: "⚡ Dal più grande persecutore al più grande missionario - miracolo di grazia!"
      }
    },

    64: {
      name: "Pietro e Cornelio",
      challenge: "In verità comprendo che Dio non fa distinzione di persone...",
      easy: {
        question: "Qual era la professione di Cornelio?",
        options: [
          "Mercante",
          "Centurione romano",
          "Sacerdote",
          "Scriba"
        ],
        hint: "Ufficiale dell'esercito romano",
        funFact: "🎖️ Primo gentile convertito ufficialmente - apertura ai non ebrei!"
      },
      medium: {
        question: "Quale visione ebbe Pietro prima di incontrare Cornelio?",
        options: [
          "Un angelo che gli parlava",
          "Un lenzuolo con animali puri e impuri",
          "Gesù che gli appariva",
          "Un tempio distrutto"
        ],
        hint: "Visione sulla purezza e impurezza",
        funFact: "🕊️ Lenzuolo con animali: Dio abolisce le distinzioni alimentari e razziali!"
      },
      hard: {
        question: "Quale principio rivoluzionario stabilì questa conversione?",
        options: [
          "I romani sono superiori",
          "Dio non fa distinzione di persone - salvezza universale",
          "Bisogna abbandonare le tradizioni",
          "La circoncisione è inutile"
        ],
        hint: "Si tratta dell'universalità della salvezza",
        funFact: "🌍 Rivoluzione spirituale: il Vangelo è per tutti i popoli senza eccezione!"
      }
    },

    65: {
      name: "La Chiesa di Antiochia",
      challenge: "Ad Antiochia i discepoli furono chiamati cristiani per la prima volta...",
      easy: {
        question: "Come furono chiamati i discepoli per la prima volta ad Antiochia?",
        options: ["Discepoli", "Cristiani", "Fedeli", "Santi"],
        hint: "Il nome che portiamo ancora oggi",
        funFact: "✝️ 'Cristiani' = 'piccoli Cristi' - nome d'onore dato dai pagani!"
      },
      medium: {
        question: "Chi venne ad insegnare ad Antiochia con Barnaba?",
        options: [
          "Pietro",
          "Paolo (Saulo)",
          "Giacomo",
          "Giovanni"
        ],
        hint: "L'antico persecutore divenuto apostolo",
        funFact: "👥 Barnaba cerca Paolo a Tarso - inizio del ministero paolino!"
      },
      hard: {
        question: "Perché Antiochia divenne così importante nella storia cristiana?",
        options: [
          "Era ricca",
          "Primo centro missionario verso i gentili",
          "Era ben situata",
          "Aveva buoni leader"
        ],
        hint: "Si tratta dell'espansione missionaria",
        funFact: "🚢 Antiochia: porto di lancio di tutte le missioni di Paolo verso l'Europa!"
      }
    }
  }
};

export default chapter5Translations;
